import { useState } from "react";

import { ComingSoon, EmptyState, PageHead, Tabs, type TabItem } from "@/components/common";
import { useActiveWorkspace } from "@/contexts/WorkspaceContext";
import { useAutospedStream } from "@/hooks/useAutospedStream";
import type { EmpresaRow } from "@/types/autosped";

import { AutospedDetail } from "./AutospedDetail";
import { AutospedList } from "./AutospedList";

type OpTab = "autosped" | "importacao" | "gestao";

const SUBTITLE: Record<OpTab, string> = {
  autosped: "Recepção e processamento automático de SPED",
  importacao: "Upload manual de documentos do cliente",
  gestao: "Ressarcimento, restituição, débitos, compensação e ofícios",
};

const TABS: TabItem<OpTab>[] = [
  { id: "autosped", label: "Autosped", icon: "zap" },
  { id: "importacao", label: "Importação", icon: "plus" },
  { id: "gestao", label: "Gestão de crédito", icon: "trending-up" },
];

export function OperacaoPage() {
  const [tab, setTab] = useState<OpTab>("autosped");

  return (
    <>
      <PageHead title="Operação" subtitle={SUBTITLE[tab]} />
      <div style={{ marginBottom: 18 }}>
        <Tabs items={TABS} active={tab} onChange={setTab} />
      </div>

      {tab === "autosped" && <AutospedSection />}
      {tab === "importacao" && (
        <ComingSoon
          title="Importação manual"
          subtitle="Receba arquivos enviados pelo cliente pelo portal e classifique como insumo."
          icon="plus"
        />
      )}
      {tab === "gestao" && (
        <ComingSoon
          title="Gestão de crédito"
          subtitle="Ressarcimento, restituição, débitos, compensação e ofícios."
          icon="trending-up"
        />
      )}
    </>
  );
}

function AutospedSection() {
  const { activeWorkspaceId } = useActiveWorkspace();
  const [selected, setSelected] = useState<EmpresaRow | null>(null);
  // SSE aberto só enquanto a seção Autosped está montada (fecha no unmount).
  useAutospedStream(activeWorkspaceId);

  if (activeWorkspaceId == null) {
    return <EmptyState icon="briefcase" title="Selecione um workspace" />;
  }
  if (selected) {
    return (
      <AutospedDetail
        workspaceId={activeWorkspaceId}
        empresa={selected}
        onBack={() => setSelected(null)}
      />
    );
  }
  return <AutospedList workspaceId={activeWorkspaceId} onOpen={setSelected} />;
}
